import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox,
  FDPaper,
  FDStack,
  FDBodyText,
  FDTitleText,
  FDHeadlineText,
} from '@facet-wealth/design';

export const CashFlowSectionMonthlySurplus = ({
  sectionResource,
}) => {
  return (
    <FDPaper maxWidth={'500px'} width={'100%'}>
      <FDBox paddingX={2} paddingY={1}>
        <FDStack direction="column" justifyContent={'space-between'} spacing={2}>
          <FDTitleText value={sectionResource.selectedOptionPrompt('sectionName')} />
          <FDBodyText size="sm" value={sectionResource.attr('description')} />
          <FDHeadlineText size="lg" value={sectionResource.attr('total')} data-test={`${sectionResource.attr('sectionName')}-total`} />
        </FDStack>
      </FDBox>
    </FDPaper>
  );
};

CashFlowSectionMonthlySurplus.propTypes = {
  sectionResource: PropTypes.object.isRequired,
};
